/**
 * Client-side shape checks for form fields.
 *
 * These exist to tell a user what to fix before a round-trip, not to decide
 * anything — the backend remains the authority on whether an address is real.
 */

/**
 * A deliberately loose address check: something before an `@`, something after
 * it, and a dot-separated tail. Anything stricter starts rejecting addresses
 * that genuinely deliver.
 */
const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isLikelyEmail = (value: string): boolean =>
  EMAIL_SHAPE.test(value.trim());
